import { Component, Input, OnInit } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import {
    EspaceDocumentaireService,
    DicpService,
    ConsentementsService,
    QuestionnaireSanteService,
    ReponseQuestionnaireSanteSimplifie,
    QuestionnaireSanteSimplifieService
} from '@kv-common-components/kx-services';
import { CommonConsentementFormComponent } from '@kv-common-components/kv-common-components';
import { Router } from '@angular/router';
import { RouterHelperService } from '@shared/services/router-helper.service';

@Component({
    selector: 'app-consentement-form',
    templateUrl: './consentement-form.component.html',
    styleUrls: ['./consentement-form.component.scss']
})
export class ConsentementFormComponent
    extends CommonConsentementFormComponent
    implements OnInit
{
    @Input() topSansSelectionMedicale: boolean;
    goBackToEspaceClientModal = false;
    constructor(
        protected logger: NGXLogger,
        public router: Router,
        private routerHelper: RouterHelperService,
        protected espaceDocumentaireService: EspaceDocumentaireService,
        protected dicpService: DicpService,
        protected routerHelperService: RouterHelperService,
        protected consentementService: ConsentementsService,
        private questionnaireSanteService: QuestionnaireSanteService
    ) {
        super(
            logger,
            espaceDocumentaireService,
            dicpService,
            consentementService
        );
    }
    ngOnInit() {
        this.questionnaireSanteService.initializeData(
            this.personne.idPersonne.toString(),
            this.idDossier.toString()
        );
        if (!this.droitOubli) {
            this.droitOubliWasDownloaded = true;
        }
    }
    navigateToEspaceClient() {
        this.router.navigateByUrl('espace-client/tableau-de-bord');
    }
    acceptConsents() {
        if (this.isValidConsentsEade()) {
            if (this.topSansSelectionMedicale) {
                this.routerHelper
                    .sendFakeQssLemoine(
                        this.personne.idPersonne.toString(),
                        this.idDossier.toString()
                    )
                    .subscribe((postValidation) => {
                        this.routerHelper.navigateAfterQSS(postValidation);
                    });
            } else {
                this.logger.debug('navigate to qss');
                this.routerHelper.navigateToQSorQSS();
            }
            localStorage.clear();
        }
    }
}
